import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/uz7iR2XBoKiwU5EPAYF5VA/Texto_del_parrafo_(3).webp';
const SITE_URL = 'https://www.fegion.shop';
const TITLE = 'Sistema Maestro PVC + DVH™ — Todo tu taller de PVC + DVH listo. Desde hoy.';
const DESCRIPTION = 'El sistema definitivo para carpinteros e instaladores de aberturas PVC en Argentina. 6 Módulos + 3 Bonos. Fórmulas, tablas de corte y protocolos listos para imprimir.';
function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
function setLink(rel: string, href: string, attrs: Record<string, string> = {}) {
  const selector = `link[rel="${rel}"][href="${href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  link.rel = rel;
  link.href = href;
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
}
if (typeof document !== 'undefined') {
  // Language + title set synchronously for best SEO + first-paint
  document.documentElement.lang = 'es-AR';
  document.title = TITLE;
  // Resource hints — added at the very top of <head> for earliest possible discovery
  const hints: Array<[string, string, Record<string, string>?]> = [['dns-prefetch', 'https://cdn.magicpatterns.com'], ['dns-prefetch', 'https://fegion.shop'], ['preconnect', 'https://cdn.magicpatterns.com', {
    crossorigin: 'anonymous'
  }], ['preconnect', 'https://fonts.googleapis.com'], ['preconnect', 'https://fonts.gstatic.com', {
    crossorigin: 'anonymous'
  }], ['preconnect', 'https://fegion.shop']];
  hints.reverse().forEach(([rel, href, attrs]) => {
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    if (attrs) Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
    document.head.insertBefore(link, document.head.firstChild);
  });
  // Preload the LCP hero image
  if (!document.querySelector(`link[rel="preload"][href="${HERO_IMAGE}"]`)) {
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.as = 'image';
    preload.href = HERO_IMAGE;
    preload.setAttribute('type', 'image/webp');
    (preload as any).fetchPriority = 'high';
    document.head.insertBefore(preload, document.head.firstChild);
  }
  // Viewport (in case the host HTML lacks it)
  if (!document.querySelector('meta[name="viewport"]')) {
    const viewport = document.createElement('meta');
    viewport.name = 'viewport';
    viewport.content = 'width=device-width, initial-scale=1, viewport-fit=cover';
    document.head.appendChild(viewport);
  }
  // Core SEO meta
  setMeta('name', 'description', DESCRIPTION);
  setMeta('name', 'robots', 'index, follow, max-image-preview:large');
  setMeta('name', 'author', 'Fegion');
  setMeta('name', 'theme-color', '#050d1a');
  setMeta('name', 'color-scheme', 'dark');
  setMeta('name', 'format-detection', 'telephone=no');
  // Open Graph
  setMeta('property', 'og:type', 'product');
  setMeta('property', 'og:locale', 'es_AR');
  setMeta('property', 'og:site_name', 'Sistema Maestro PVC + DVH');
  setMeta('property', 'og:title', TITLE);
  setMeta('property', 'og:description', DESCRIPTION);
  setMeta('property', 'og:url', SITE_URL);
  setMeta('property', 'og:image', HERO_IMAGE);
  setMeta('property', 'og:image:alt', 'SISTEMA MAESTRO PVC + DVH™');
  setMeta('property', 'og:image:width', '1024');
  setMeta('property', 'og:image:height', '1024');
  // Twitter
  setMeta('name', 'twitter:card', 'summary_large_image');
  setMeta('name', 'twitter:title', TITLE);
  setMeta('name', 'twitter:description', DESCRIPTION);
  setMeta('name', 'twitter:image', HERO_IMAGE);
  // Canonical
  setLink('canonical', SITE_URL);
  // ─────────────────────────────────────────────────────────────
  // META (Facebook) PIXEL — canonical install.
  // Inserted synchronously as a literal <script> tag so the Meta Pixel
  // Helper extension can detect it during its first HTML scan.
  // ─────────────────────────────────────────────────────────────
  const PIXEL_ID = '904978025482552';
  if (!document.querySelector('script[data-fb-pixel-init]')) {
    // 1. Preconnect for a faster handshake
    if (!document.querySelector('link[rel="preconnect"][href="https://connect.facebook.net"]')) {
      const pc = document.createElement('link');
      pc.rel = 'preconnect';
      pc.href = 'https://connect.facebook.net';
      pc.crossOrigin = 'anonymous';
      document.head.appendChild(pc);
    }
    // 2. Inline initializer — the exact snippet Meta provides in the
    //    install wizard. Inlined as a real <script> tag so detectors
    //    (Pixel Helper, Tag Assistant) see it in the DOM tree.
    const initScript = document.createElement('script');
    initScript.setAttribute('data-fb-pixel-init', PIXEL_ID);
    initScript.text = `
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');
`.trim();
    document.head.appendChild(initScript);
  }
  // Noscript fallback (appended once body exists)
  const appendNoscript = () => {
    if (!document.body) return;
    if (document.querySelector(`noscript[data-fb-pixel="${PIXEL_ID}"]`)) return;
    const ns = document.createElement('noscript');
    ns.setAttribute('data-fb-pixel', PIXEL_ID);
    ns.innerHTML = `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1" />`;
    document.body.appendChild(ns);
  };
  if (document.body) {
    appendNoscript();
  } else {
    document.addEventListener('DOMContentLoaded', appendNoscript, {
      once: true
    });
  }
  // Structured data (Product + FAQ + Organization)
  if (!document.querySelector('script[data-mp-jsonld="product"]')) {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-mp-jsonld', 'product');
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@graph': [{
        '@type': 'Product',
        name: 'Sistema Maestro PVC + DVH™',
        image: [HERO_IMAGE],
        description: DESCRIPTION,
        brand: {
          '@type': 'Brand',
          name: 'Fegion'
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.9',
          reviewCount: '150',
          bestRating: '5'
        },
        offers: [{
          '@type': 'Offer',
          name: 'Sistema Maestro Completo',
          price: '19990',
          priceCurrency: 'ARS',
          availability: 'https://schema.org/InStock',
          url: 'https://fegion.shop/cart/47115288019083:1'
        }, {
          '@type': 'Offer',
          name: 'Sistema Maestro + Pack de Aceleración',
          price: '29990',
          priceCurrency: 'ARS',
          availability: 'https://schema.org/InStock',
          url: 'https://fegion.shop/cart/47115293393035:1'
        }]
      }, {
        '@type': 'FAQPage',
        mainEntity: [{
          '@type': 'Question',
          name: '¿Sirve si no uso Aluplast?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí. Cubre Aluplast, Kommerling, Rehau y sistemas nacionales.'
          }
        }, {
          '@type': 'Question',
          name: '¿Cómo recibo el material?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Inmediatamente después del pago. Menos de 5 minutos.'
          }
        }, {
          '@type': 'Question',
          name: '¿Puedo imprimirlo?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí. Todo está diseñado para imprimir y usar en el taller.'
          }
        }, {
          '@type': 'Question',
          name: '¿Sirve si empiezo de cero en PVC?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí. El Módulo 1 te lleva desde los fundamentos.'
          }
        }, {
          '@type': 'Question',
          name: '¿Necesito maquinaria especial?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'No. Funciona con las herramientas que ya tenés.'
          }
        }, {
          '@type': 'Question',
          name: '¿Tiene garantía real?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sí. 7 días, 100% de devolución, sin preguntas.'
          }
        }]
      }, {
        '@type': 'Organization',
        name: 'Fegion',
        url: SITE_URL,
        logo: HERO_IMAGE,
        sameAs: ['https://www.instagram.com/fegion1/'],
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer support',
          email: 'soporteoficialfegion@gmail.com',
          availableLanguage: ['Spanish']
        }
      }]
    });
    document.head.appendChild(script);
  }
}
render(<App data-id="element-458" />, document.getElementById('root'));